import { Component, Inject, OnInit, signal } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { BehaviorSubject, timer } from "rxjs";
import { MenuAction } from "src/app/models/menuAction.model";
import { SortColumn } from "src/app/models/sortColumn.model";
import { ITableColumn } from "src/app/models/tableColumns";
import { quarantineUserTableColumns } from "src/app/models/tableColumns/quarantineUserColumns.model";
import { QuarantineUserTableRowViewModel } from "src/app/models/viewModels/quarantineUserTableRowViewModel";
import { IncidentCreatedSuccessfullyDialogComponent } from "../incident-created-successfully-dialog/incident-created-successfully-dialog.component";

interface QuarantineUser {
    name: string;
    email: string;
    role: string;
}

@Component({
    selector: "app-quarantine-user-dialog",
    templateUrl: "./quarantine-user-dialog.component.html",
    styleUrls: ["./quarantine-user-dialog.component.scss"],
})
export class QuarantineUserDialogComponent implements OnInit {
    public waitingForResponse = false;
    public actions = new FormControl("");
    public actionOnUsers = new FormControl("");
    public actionList: string[] = ["Terminate Action Sessions", "Rotate MFA Credentials", "Disable User Account"];
    public selectedUsersNames = "";

    public sortedColumn$ = new BehaviorSubject<SortColumn | undefined>(undefined);
    public pageInfo$ = new BehaviorSubject({
        number: 1,
        currSize: 1,
        maxSize: 2,
        totalItems: 1,
        totalPages: 1,
    });
    public isLoading$ = new BehaviorSubject<boolean>(false);
    public columns = signal<ITableColumn[]>(quarantineUserTableColumns);
    public usersCurrentPage$ = new BehaviorSubject<QuarantineUserTableRowViewModel[]>([]);
    public showNoData = false;
    public totalItems = 0;
    public multiSelectedMenuActions$: BehaviorSubject<MenuAction[]> = new BehaviorSubject<MenuAction[]>([]);
    public checkedRows = new Set<string>();

    constructor(
        public dialogRef: MatDialogRef<QuarantineUserDialogComponent>,
        private _matDialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: { users: QuarantineUser[] },
    ) {}

    ngOnInit(): void {
        this.usersCurrentPage$.next(this.data.users.map((user) => this._transformToViewModel(user)));
    }

    public rowUnselected(): void {
        console.log("Row unselected");
    }

    public rowSelected(selectedRow: QuarantineUserTableRowViewModel): void {
        console.log("Row Selected");
        console.log(selectedRow);
    }

    public onCheckboxClick(event: Set<string>): void {
        const selectedUserEmail = [...event][0];
        const user = this.data.users.find((user) => user.email === selectedUserEmail);
        this.selectedUsersNames = user?.name || "";
        //this.selectedUsersNames = [...event].map((id) => this.data.users.find((user) => user.email === id)?.name).join(',');
    }

    public onExecuteActions(): void {
        console.log("Execute Actions");

        this.waitingForResponse = true;
        timer(1000).subscribe(() => {
            this._matDialog.open(IncidentCreatedSuccessfullyDialogComponent, {
                data: {},
                disableClose: false,
                panelClass: "sized-popup-dialog-container",
                width: `600px`,
                height: `150px`,
            });
            this.dialogRef.close();
        });
    }

    public isExecuteActionsEnable(): boolean {
        return this.selectedUsersNames !== "" && this.actionOnUsers.value === this.selectedUsersNames;
    }

    public onClose(): void {
        this.dialogRef.close();
    }

    private _transformToViewModel(row: QuarantineUser): QuarantineUserTableRowViewModel {
        return {
            rowId: row.email,
            name: row.name,
            email: row.email,
            role: row.role,
            clickable: false,
        };
    }
}
